import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from '../context/CookieConsentContext';

const ConsentEmbed = ({
  category = 'functional',
  title,
  src,
  className = '',
  iframeClassName = '',
  height,
  ...iframeProps
}) => {
  const { t } = useTranslation();
  const { allows, openSettings } = useCookieConsent();

  if (!allows(category)) {
    return (
      <div
        className={`flex flex-col items-center justify-center bg-[#242424] text-white text-center px-6 py-10 ${className}`}
        style={height ? { minHeight: height } : undefined}
      >
        <p className="text-16 font-light mb-5 max-w-md">{t('cookie.embedBlocked', { title })}</p>
        <button
          type="button"
          onClick={openSettings}
          className="border border-white/60 px-8 py-2.5 text-16 font-light hover:bg-white hover:text-[#242424] duration-200"
        >
          {t('cookie.openSettings')}
        </button>
      </div>
    );
  }

  return (
    <iframe
      title={title}
      src={src}
      className={iframeClassName}
      height={height}
      {...iframeProps}
    />
  );
};

export default ConsentEmbed;
